import { useEffect } from 'react';

const usePlayPauseActions = (
  dataPosition,
  isModalOpen,
  isPlaying,
  setIsPlaying,
  setVideoPlayer,
  type,
  videoId,
  videoPlayer,
) => {
  const dataLayerEvent = (playOrPause) => {
    dataLayer.push({
      event: 'cta clicked',
      label: `${playOrPause} Button`,
      cta_text: playOrPause,
      cta_position: dataPosition,
    });
  };

  useEffect(() => {
    let isSubscribed = true;

    if (isModalOpen || type === 'isThumbnailInline' || type === 'isThumbnailOnly') {
      window._wq = window._wq || [];

      const embedInitConfig = {
        id: videoId,
        onReady(video) {
          if (!isSubscribed) return;

          setVideoPlayer(video);

          video.bind('play', () => {
            if (!isSubscribed) return;

            setIsPlaying(true);
            dataLayerEvent('Play');
            video.play();
          });

          video.bind('pause', () => {
            if (!isSubscribed) return;

            video.pause();
            setIsPlaying(false);
            dataLayerEvent('Pause');
          });
        },
      };

      _wq.push(embedInitConfig);
    }

    return () => {
      isSubscribed = false; // Mark component as unmounted
    };
  }, [type, videoId, isModalOpen]);

  useEffect(() => {
    if (isPlaying && videoPlayer) {
      videoPlayer.play();
    }
  }, [isPlaying, videoPlayer]);
};

export default usePlayPauseActions;
